(function () {
  function initPurchase(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-er-purchase]'));
    if (scope instanceof Element && scope.matches('[data-er-purchase]')) sections.push(scope);

    sections.forEach(function (section) {
      if (section.dataset.purchaseReady === 'true') return;
      section.dataset.purchaseReady = 'true';

      var form = section.querySelector('.er-purchase__form');
      var select = section.querySelector('[data-er-purchase-select]');
      var price = section.querySelector('[data-er-purchase-price]');
      var image = section.querySelector('[data-er-purchase-image]');
      var note = section.querySelector('[data-er-purchase-note]');
      var availability = section.querySelector('[data-er-purchase-availability]');
      var add = section.querySelector('[data-er-purchase-add]');
      var quantity = section.querySelector('[data-er-purchase-quantity]');
      var buyNow = section.querySelector('[data-er-purchase-buy-now]');
      if (!form || !select || !add || !quantity) return;

      Array.prototype.forEach.call(select.options, function (option) {
        if (!option.dataset.image) return;
        var preload = new Image();
        preload.src = option.dataset.image;
      });

      function updateVariant() {
        var option = select.options[select.selectedIndex];
        var isAvailable = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        add.disabled = !isAvailable;
        add.textContent = isAvailable ? section.dataset.addText : section.dataset.soldOutText;
        if (availability) availability.textContent = isAvailable ? section.dataset.inStockText || '' : section.dataset.soldOutText;
        if (note) note.textContent = option.dataset.title || option.textContent;
        if (image && option.dataset.image) image.src = option.dataset.image;
      }

      select.addEventListener('change', updateVariant);
      section.querySelectorAll('[data-er-quantity]').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = Math.max(1, parseInt(quantity.value, 10) || 1);
          quantity.value = button.dataset.erQuantity === 'increase' ? current + 1 : Math.max(1, current - 1);
        });
      });
      if (buyNow) buyNow.addEventListener('click', function () {
        if (add.disabled) return;
        fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: select.value, quantity: Math.max(1, parseInt(quantity.value, 10) || 1) })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          window.location.assign('/checkout');
        }).catch(function () { form.submit(); });
      });
      updateVariant();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPurchase(document); });
  else initPurchase(document);
  document.addEventListener('shopify:section:load', function (event) { initPurchase(event.target); });
})();
